"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsync = void 0;
var tslib_1 = require("tslib");
var swr_1 = (0, tslib_1.__importDefault)(require("swr"));
function useAsync(asyncFunction, args) {
    var _a = (0, swr_1.default)(function () { return [asyncFunction, args.toString()]; }, function () { return asyncFunction(args); }, {
        dedupingInterval: 30000,
        revalidateOnFocus: false,
        onErrorRetry: function (error) { var _a; return ![401, 403].includes(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) || 0); },
    }), data = _a.data, error = _a.error;
    return {
        pending: !data && !error,
        error: error,
        value: data,
    };
}
exports.useAsync = useAsync;
